import { AddOn } from '@weave/schema-gen-ts/dist/schemas/package-service/v1/package.pb';
import { SalesforceAccountProductBundle } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { i18next } from '@frontend/i18n';

export enum IntegrationPackagesEnum {
  PLUS = 'PLUS',
  CORE = 'CORE',
}

export enum BundleAddOnsEnum {
  BASE = 'BASE',
  COORDINATE = 'COORDINATE',
  ATTRACT = 'ATTRACT',
}

export const IntegrationPackagesLabel: Record<IntegrationPackagesEnum, string> = {
  [IntegrationPackagesEnum.CORE]: i18next.t('Core', { ns: 'salesDev' }),
  [IntegrationPackagesEnum.PLUS]: i18next.t('Plus', { ns: 'salesDev' }),
};

export const BundleAddOnsLabel: Record<BundleAddOnsEnum, string> = {
  [BundleAddOnsEnum.BASE]: i18next.t('Base', { ns: 'salesDev' }),
  [BundleAddOnsEnum.COORDINATE]: i18next.t('Coordinate', { ns: 'salesDev' }),
  [BundleAddOnsEnum.ATTRACT]: i18next.t('Attract', { ns: 'salesDev' }),
};

export const FeatureAddOnsLabel: Partial<Record<AddOn, string>> = {
  [AddOn.CALL_INTELLIGENCE]: i18next.t('Call Intelligence', { ns: 'salesDev' }),
  [AddOn.PRACTICE_ANALYTICS]: i18next.t('Practice Analytics (Dental Only)', { ns: 'salesDev' }),
  [AddOn.WIV]: i18next.t('Weave Insurance Verification', { ns: 'salesDev' }),
};

const baseBundleMap: Record<string, SalesforceAccountProductBundle> = {
  [`${IntegrationPackagesEnum.CORE}_SO`]: SalesforceAccountProductBundle.PRODUCT_BUNDLE_WEAVE_BASE_NON_INTEGRATED,
  [`${IntegrationPackagesEnum.PLUS}_SO`]: SalesforceAccountProductBundle.PRODUCT_BUNDLE_WEAVE_BASE_INTEGRATED,
  [`${IntegrationPackagesEnum.PLUS}_phones`]:
    SalesforceAccountProductBundle.PRODUCT_BUNDLE_WEAVE_BASE_PHONES_INTEGRATED,
  [`${IntegrationPackagesEnum.CORE}_phones`]: SalesforceAccountProductBundle.PRODUCT_BUNDLE_WEAVE_BASE_PHONES,
};

export const computeDemoBundle = (
  integration: IntegrationPackagesEnum,
  phones: boolean
): SalesforceAccountProductBundle => {
  const key = `${integration}_${phones ? 'phones' : 'SO'}`;
  return baseBundleMap[key];
};

const addOnMap: Record<string, AddOn> = {
  [`${BundleAddOnsEnum.COORDINATE}_${IntegrationPackagesEnum.PLUS}`]: AddOn.COORDINATE_INTEGRATED,
  [`${BundleAddOnsEnum.COORDINATE}_${IntegrationPackagesEnum.CORE}`]: AddOn.COORDINATE,
  [`${BundleAddOnsEnum.ATTRACT}_${IntegrationPackagesEnum.PLUS}`]: AddOn.ATTRACT_INTEGRATED,
  [`${BundleAddOnsEnum.ATTRACT}_${IntegrationPackagesEnum.CORE}`]: AddOn.ATTRACT,
};

export const computeDemoAddOns = (
  integration: IntegrationPackagesEnum,
  selectedAddOns: BundleAddOnsEnum[],
  featureAddOns: AddOn[] = []
): AddOn[] => {
  return [
    ...selectedAddOns
      .filter((addon) => addon !== BundleAddOnsEnum.BASE)
      .map((addon) => addOnMap[`${addon}_${integration}`]),
    ...featureAddOns,
  ];
};

/**
 * @deprecated This is a legacy bundle package enum which will be removed in the future.
 */
export enum LegacyBundlePackagesEnum {
  ULTIMATE = 'ULTIMATE',
  ELITE = 'ELITE',
  PRO = 'PRO',
  ESSENTIALS = 'ESSENTIALS',
}

/**
 * @deprecated This is a legacy bundle option enum which will be removed in the future.
 */
export enum LegacyBundleOptionalsEnum {
  SOFTWARE_ONLY = 'SOFTWARE_ONLY',
}

const SALESFORCE_BUNDLE_PREFIX = 'PRODUCT_BUNDLE_WEAVE';

type SalesforcePackageParts = {
  integrationPackage: IntegrationPackagesEnum;
  bundlePackage: LegacyBundlePackagesEnum;
  bundleOptional?: LegacyBundleOptionalsEnum;
};

/**
 * @deprecated This is a legacy bundle package label map which will be removed in the future.
 */
export const LegacyBundlePackagesLabel: Record<LegacyBundlePackagesEnum, string> = {
  [LegacyBundlePackagesEnum.ULTIMATE]: 'Ultimate',
  [LegacyBundlePackagesEnum.ELITE]: 'Elite',
  [LegacyBundlePackagesEnum.PRO]: 'Pro',
  [LegacyBundlePackagesEnum.ESSENTIALS]: 'Essentials',
};

/**
 *
 * @deprecated This is a legacy utility function which will be removed in the future.
 */
export const getLegacySalesforceBundlePackage = (
  bundleParts: SalesforcePackageParts
): SalesforceAccountProductBundle => {
  const { integrationPackage, bundlePackage, bundleOptional } = bundleParts;
  const bundlePartsList = [SALESFORCE_BUNDLE_PREFIX, integrationPackage, bundlePackage];
  if (bundleOptional) {
    bundlePartsList.splice(2, 0, bundleOptional);
  }
  return SalesforceAccountProductBundle[bundlePartsList.join('_') as SalesforceAccountProductBundle];
};
